<template>
  <div class="no-purchased">
    <div class="img">
      <img :src="list[id].path" alt />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: [Number, String],
    default: 0,
  },
  data() {
    return {
      list: {
        1: {
          id: 1,
          name: '标杆游学',
          path: require('@/assets/images/vip/p-benchmarking.png'),
        },
        2: {
          id: 2,
          name: '深度研学',
          path: require('@/assets/images/vip/p-research.png'),
        },
        3: {
          id: 3,
          name: '围炉夜话',
          path: require('@/assets/images/vip/p-talk.png'),
        },
        4: {
          id: 4,
          name: '进化社群',
          path: require('@/assets/images/vip/p-social.png'),
        },
        5: {
          id: 5,
          name: '专属交流',
          path: require('@/assets/images/vip/p-communication.png'),
        },
        6: {
          id: 6,
          name: '私教坊',
          path: require('@/assets/images/vip/p-private.png'),
        },
        7: {
          id: 7,
          name: '训练营',
          path: require('@/assets/images/vip/p-train.png'),
        },
        8: {
          id: 8,
          name: '8折购课',
          path: require('@/assets/images/vip/p-discount.png'),
        },
      },
    }
  },
  created() {},
}
</script>

<style lang="less" scoped>
.no-purchased {
  padding-top: 66px;
  .img {
    img {
      width: 686px;
      height: 1072px;
    }
  }
}
</style>
